<template>
    <!--
        Root of the Special Order widget. Sits as a single .widget-root
        card inside the Shadow DOM. Keep this component thin — it's
        just the chrome around the actual form.
    -->
    <div class="widget-root">
        <h2 class="title">Special Order Request</h2>
        <p class="subtitle">
            Tell us what you're after and we'll get back to you.
        </p>
        <Form :config="config" />
    </div>
</template>

<script setup>
import Form from './components/Form.vue'

defineProps({
    config: { type: Object, required: true },
})
</script>
